<template>
  <b-container fluid>
    <!-- Main table element -->
    <b-table
        :items="planDetails"
        :fields="fields"
        :busy.sync="loading"
        stacked="md"
        show-empty
        @filtered="onFiltered"
        bordered
        borderless
        striped
        empty-filtered-text="لا يوجد نتائج تطابق البحث"
        empty-text="لا يوجد سجلات لعرضها"
    >
      <template #table-busy>
        <div class="text-center text-info my-2">
          <b-spinner class="align-middle mx-2"></b-spinner>
          <strong>جاري التحميل...</strong>
        </div>
      </template>
      <template #cell(program_id)="row">
        <!-- <div class="d-flex align-items-center" v-if="row.value === 0 || row.value === null">
          <h5 class="mb-0">
            نشاط طارئ
          </h5>
        </div> -->
        <div class="d-flex align-items-center">
          <h5 class="mb-0">
            {{ row.value }}
          </h5>
        </div>
      </template>
      <template #cell(governorate_id)="row">
        <div v-for="item in row.value" class="d-flex align-items-center">
          <span class="mb-0">
            {{ item.name_ar }} 
          </span>
        </div>
      </template>

      <template v-for="n in 12" v-slot:[`cell(${n})`]="row">
        <feather-icon
            v-if="
            row.item.months &&
            (row.item.months.includes(n) ||
              row.item.months.includes(`${n}`))
          "
            size="15"
            class="text-success"
            icon="CheckCircleIcon"
        />
      </template>

    </b-table>
  </b-container>
</template>

<script>
import {
  BButton,
  BCard,
  BModal,
  BTable,
  BRow,
  BCol,
  BContainer,
  BFormGroup,
  BInputGroup,
  BPagination,
  BFormSelect,
  BFormCheckbox,
  BFormCheckboxGroup,
  BInputGroupAppend,
  BDropdown,
  BDropdownItem,
  BSpinner,
} from "bootstrap-vue";
export default {
  components: {
    BButton,
    BCard,
    BModal,
    BTable,
    BRow,
    BCol,
    BContainer,
    BFormGroup,
    BInputGroup,
    BPagination,
    BFormSelect,
    BFormCheckbox,
    BFormCheckboxGroup,
    BInputGroupAppend,
    BDropdown,
    BDropdownItem,
    BSpinner,
  },
  props: {
    planDetails: Array,
    loading: Boolean,
    isArchived: {
      type: Boolean,
      default: () => true,
    },
    isUrgent: {
      type: Boolean,
      default: () => false,
    },
    evaluated: {
      type: Boolean,
      default: () => false,
    },
  },
  computed:{

    fields(){
      return this.isUrgent === true ? [
        {
          key: "activity_id.name",
          label: "النشاط",
          class: "text-center px-1",
        },
        {
          key: "governorate_id",
          label: "المحافظة",
          sortDirection: "desc",
          class: "th-width",
        },
        {
          key: "1",
          label: "ك 2",
          class: "text-center px-1",
        },
        {
          key: "2",
          label: "شباط",
          class: "text-center px-1",
        },
        {
          key: "3",
          label: "آذار",
          class: "text-center px-1",
        },
        {
          key: "4",
          label: "نيسان",
          class: "text-center px-1",
        },
        {
          key: "5",
          label: "أيار",
          class: "text-center px-1",
        },
        {
          key: "6",
          label: "حزيران",
          class: "text-center px-1",
        },
        {
          key: "7",
          label: "تموز",
          class: "text-center px-1",
        },
        {
          key: "8",
          label: "آب",
          class: "text-center px-1",
        },
        {
          key: "9",
          label: "أيلول",
          class: "text-center px-1",
        },
        {
          key: "10",
          label: "ت 1",
          class: "text-center px-1",
        },
        {
          key: "11",
          label: "ت 2",
          class: "text-center px-1",
        },
        {
          key: "12",
          label: "ك 1",
          class: "text-center px-1",
        },

        {
          key: "beneficiaries_number",
          label: "عدد المستفيدين",
          class: "text-center px-1",
        },
        {
          key: "funds",
          label: "الموازنة",
          class: "text-center px-1",
        },
      ] : [
        {
          key: "program_id.name",
          label: "البرنامج",
          sortDirection: "desc",
          class: "th-width",
        },
        {
          key: "governorate_id",
          label: "المحافظة",
          sortDirection: "desc",
          class: "th-width",
        },
        {
          key: "activity_id.name",
          label: "النشاط",
          class: "text-center px-1",
        },
        {
          key: "1",
          label: "ك 2",
          class: "text-center px-1",
        },
        {
          key: "2",
          label: "شباط",
          class: "text-center px-1",
        },
        {
          key: "3",
          label: "آذار",
          class: "text-center px-1",
        },
        {
          key: "4",
          label: "نيسان",
          class: "text-center px-1",
        },
        {
          key: "5",
          label: "أيار",
          class: "text-center px-1",
        },
        {
          key: "6",
          label: "حزيران",
          class: "text-center px-1",
        },
        {
          key: "7",
          label: "تموز",
          class: "text-center px-1",
        },
        {
          key: "8",
          label: "آب",
          class: "text-center px-1",
        },
        {
          key: "9",
          label: "أيلول",
          class: "text-center px-1",
        },
        {
          key: "10",
          label: "ت 1",
          class: "text-center px-1",
        },
        {
          key: "11",
          label: "ت 2",
          class: "text-center px-1",
        },
        {
          key: "12",
          label: "ك 1",
          class: "text-center px-1",
        },

        {
          key: "beneficiaries_number",
          label: "عدد المستفيدين",
          class: "text-center px-1",
        },
        {
          key: "funds",
          label: "الموازنة",
          class: "text-center px-1",
        },
      ]
    }
  },
  data() {
    return {
      items: [
        {
          name: "برنامج محو الأمية",
          num: 2904,
          price: 2500000,
          1: true,
        },
      ],
      activitesFields: [
        {
          key: "name",
          label: "اسم النشاط",
          sortDirection: "desc",
          class: "th-width pl-5",
        },
        {
          key: "1",
          label: "ك 2",
          class: "text-center px-2",
        },
        {
          key: "2",
          label: "شباط",
          class: "text-center px-2",
        },
        {
          key: "3",
          label: "آذار",
          class: "text-center px-2",
        },
        {
          key: "4",
          label: "نيسان",
          class: "text-center px-2",
        },
        {
          key: "5",
          label: "أيار",
          class: "text-center px-2",
        },
        {
          key: "6",
          label: "حزيران",
          class: "text-center px-2",
        },
        {
          key: "7",
          label: "تموز",
          class: "text-center px-2",
        },
        {
          key: "8",
          label: "آب",
          class: "text-center px-2",
        },
        {
          key: "9",
          label: "أيلول",
          class: "text-center px-2",
        },
        {
          key: "10",
          label: "ت 1",
          class: "text-center px-2",
        },
        {
          key: "11",
          label: "ت 2",
          class: "text-center px-2",
        },
        {
          key: "12",
          label: "ك 1",
          class: "text-center px-2",
        },

        {
          key: "beneficiaries_number",
          label: "عدد المستفيدين",
          class: "text-center px-2",
        },
        {
          key: "funds",
          label: "الموازنة",
          class: "text-center px-2",
        },

        { key: "actions", label: "" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, { value: 100, text: "Show a lot" }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style lang="scss">
.b-table-details {
  .table-striped tbody tr:nth-of-type(odd) {
    background-color: #f8f8f8;
  }
  > td {
    padding-left: 0px;
    padding-right: 0px;
  }
  th {
    padding: 0 2rem;
    visibility: hidden;

    div {
      visibility: hidden;
    }
    font-size: xx-small;
  }
}
.th-width {
  width: 200px;
}
</style>
